import { useEffect, useState } from "react";
import { postData } from "../../ApiServices/ApiService";
import { ORG_EXPENSE_LIST_FILTER, ORG_GET_ALL_CODES_LIST, ACCOUNT_DASHBOARD_SUMMARY_URL, ACCOUNT_NET_BALANCE_URL, ACCOUNT_REPORTS_URL ,ORG_DISBURSEMENT_LIST_FILTER, ORG_DISBURSEMENT_APPROVALS} from "../../ApiServices/BaseURL";
import { logFrontendException } from "../../Utils/Exception";
import { useTheme } from "../../GlobalContext/GlobalContext";

const ExpenseManagementController = () => {
    const [expenseList, setExpenseList] = useState([]);
    const [expenseLoading, setExpenseLoading] = useState(false);
    const [expenseError, setExpenseError] = useState("");
    const { setIsLoginPopup } = useTheme();
    const [expenseApproveList, setExpenseApproveList] = useState([]);
    const [expenseApproveLoading, setExpenseApproveLoading] = useState(false);
    const [expenseApproveError, setExpenseApproveError] = useState("");

    const [yearLoading, setYearLoading] = useState(false);
    const [yearError, setYearError] = useState('');
    const [yearList, setYearList] = useState([]);

    const [selectedYear, setSelectedYear] = useState(null);

    const [dashboardSummary, setDashboardSummary] = useState({});
    const [netBalanceReport, setNetBalanceReport] = useState({});

    const [dashboardSummaryLoading, setDashboardSummaryLoading] = useState(false);
    const [netBalanceLoading, setNetBalanceLoading] = useState(false);

    const [dashboardSummaryError, setDashboardSummaryError] = useState('');
    const [netBalanceError, setNetBalanceError] = useState('');

    const [totalExpenseData, setTotalExpenseData] = useState({});
    const [totalExpenseLoading, setTotalExpenseLoading] = useState(false);
    const [totalExpenseError, setTotalExpenseError] = useState("");

    const [disbursementReportData, setDisbursementReportData] = useState({});
    const [disbursementReportLoading, setDisbursementReportLoading] = useState(false);
    const [disbursementReportError, setDisbursementReportError] = useState("");

    const [expenseReportData, setExpenseReportData] = useState({});
    const [expenseReportLoading, setExpenseReportLoading] = useState(false);
    const [expenseReportError, setExpenseReportError] = useState("");

    const [rejectionReportData, setRejectionReportData] = useState({});
    const [rejectionReportLoading, setRejectionReportLoading] = useState(false);
    const [rejectionReportError, setRejectionReportError] = useState("");


    const [disbursementList, setDisbursementList] = useState([]);
    const [disbursementbLoading, setDisbursementLoading] = useState(false);
    const [disbursementError, setDisbursementError] = useState("");

    const [disbursementApproveList, setDisbursementApproveList] = useState([]);
    const [disbursementApproveLoading, setDisbursementApproveLoading] = useState(false);
    const [disbursementApproveError, setDisbursementApproveError] = useState("");

    const pageName = "ExpenseManagementController";
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;

    const fetchExpenses = async () => {
        setExpenseLoading(true);
        setExpenseError("");
        setExpenseList([]);
        try {
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payload = {
                action_code: "Expense_List",
                emp_id_auth: storedUserInfo?.emp_id,
            };

            const response = await postData(ORG_EXPENSE_LIST_FILTER, payload);
            const responseData = await response.json();


            if (response.status === 200 && responseData.status_code === 200) {
                if (responseData.message.toLowerCase() === "success") {
                    if (responseData?.dataJ?.length > 0) {
                        setExpenseList(responseData?.dataJ || []);
                    } else {
                        setExpenseError(responseData?.info || "Failed to fetch expenses.");
                        // Log exception to backend (User Id,Page Name,Method Name,Response/error)
                        logFrontendException(storedUserId, pageName, "fetchExpenses", responseData || '');
                    }
                } else {
                    setExpenseError(responseData?.info || "Failed to fetch expenses.");
                    //  Log exception to backend (User Id,Page Name,Method Name,Response/error)
                    logFrontendException(storedUserId, pageName, "fetchExpenses", responseData || '');
                }
            }else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                
                setExpenseError("Unauthorized access. Your session may have expired. Please log in again.");
                setIsLoginPopup(true)
                //  Log exception to backend (User Id,Page Name,Method Name,Response/error)
                logFrontendException(storedUserId, pageName, "fetchExpenses", responseData || response || '');
                       
                } else {
                setExpenseError(responseData?.info || "Failed to fetch expenses.");
                //  Log exception to backend (User Id,Page Name,Method Name,Response/error)
                logFrontendException(storedUserId, pageName, "fetchExpenses", responseData || '');
            }
        } catch (err) {
            setExpenseError("Network error. Please try again.");
            logFrontendException(storedUserId, pageName, "fetchExpenses", err || '');
        } finally {
            setExpenseLoading(false);
        }
    };

    const fetchExpenseApprove = async () => {
        setExpenseApproveLoading(true);
        setExpenseApproveError("");
        setExpenseApproveList([]);
        try {
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payload = {
                action_code: "Approval_List",
                emp_id_auth: storedUserInfo?.emp_id,
            };

            const response = await postData(ORG_EXPENSE_LIST_FILTER, payload);
            const responseData = await response.json();

            if (response.status === 200) {
                if(responseData?.status_code === 200) {
                    if (responseData?.message.toLowerCase() === "success") {
                        if (responseData?.dataJ?.length > 0) {
                            setExpenseApproveList(responseData?.dataJ || []);
                        } else {
                            setExpenseApproveError(responseData?.info || "Failed to fetch expenses.");
                            logFrontendException(storedUserId, pageName, "fetchExpenseApprove", responseData?.info || '');
                        }
                    } else {
                        setExpenseApproveError(responseData?.info || "Failed to fetch expenses.");
                        logFrontendException(storedUserId, pageName, "fetchExpenseApprove", responseData?.info || '');
                    }
                } else {
                    setExpenseApproveError(responseData?.info || "Failed to fetch expenses.Please try again.");
                    logFrontendException(storedUserId, pageName, "fetchExpenseApprove", responseData || '');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                
                setExpenseApproveError("Unauthorized access. Your session may have expired. Please log in again.");
                setIsLoginPopup(true)
                //  Log exception to backend (User Id,Page Name,Method Name,Response/error)
                logFrontendException(storedUserId, pageName, "fetchExpenseApprove", responseData || response || '');
            } else {
                setExpenseApproveError(responseData?.info || "Failed to fetch expenses.");
                logFrontendException(storedUserId, pageName, "fetchExpenseApprove", responseData || '');
            }
        } catch (err) {
            setExpenseApproveError("Network error. Please try again.");
            logFrontendException(storedUserId, pageName, "fetchExpenseApproveCatch", err || '');
        } finally {
            setExpenseApproveLoading(false);
        }
    };
    
    const fetchDisbursementList = async () => {
        setDisbursementLoading(true);
        setDisbursementError("");
        setDisbursementList([]);
        try {
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payload = {
                action_code: "disbursement_list",
                emp_id_auth: storedUserInfo?.emp_id,
            };

            const response = await postData(ORG_DISBURSEMENT_LIST_FILTER, payload);
            const responseData = await response.json();

            if (response.status === 200) {
                if (responseData.status_code === 200) {
                    if (responseData.message.toLowerCase() === "success") {
                        if (responseData?.dataJ?.length > 0) {
                            setDisbursementList(responseData?.dataJ || []);
                        }else{
                            setDisbursementError(responseData?.info || "Failed to fetch expenses.");
                            logFrontendException(storedUserId, pageName, "fetchExpenseApprove", responseData?.info || '');
                        }
                    } else {
                        setDisbursementError(responseData?.info || "Failed to fetch expenses.");
                        logFrontendException(storedUserId, pageName, "fetchExpenseApprove", responseData?.info || '');
                    }
                } else {
                    setDisbursementError(responseData?.info || "Failed to fetch expenses.");
                    logFrontendException(storedUserId, pageName, "fetchExpenseApprove", responseData || '');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                
                setDisbursementError("Unauthorized access. Your session may have expired. Please log in again.");
                setIsLoginPopup(true)
                //  Log exception to backend (User Id,Page Name,Method Name,Response/error)
                logFrontendException(storedUserId, pageName, "fetchExpenseApprove", responseData || response || '');
            } else {
                setDisbursementError(responseData?.info || "Failed to fetch expenses.");
                logFrontendException(storedUserId, pageName, "fetchExpenseApprove", responseData || '');
            }
        } catch (err) {
            setDisbursementError("Network error. Please try again.");
            logFrontendException(storedUserId, pageName, "fetchExpenseApprove", err || '');
        } finally {
            setDisbursementLoading(false);
        }
    };
    const fetchDisbursementApprove = async () => {
        setDisbursementApproveLoading(true);
        setDisbursementApproveError("");
        setDisbursementApproveList([]);
        try {
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payload = {
                action_type: "disbursement_approval_list",
                emp_id_auth: storedUserInfo?.emp_id,
            };

            const response = await postData(ORG_DISBURSEMENT_APPROVALS, payload);
            const responseData = await response.json();

            if (response.status === 200) {
                if(responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === "success") {
                        if (responseData?.dataJ?.length > 0) {
                            setDisbursementApproveList(responseData?.dataJ || []);
                        } else{
                            setDisbursementApproveError(responseData?.info || "Failed to fetch disbursement.");
                            logFrontendException(storedUserId, pageName, "fetchDisbursementApprove", responseData?.info || '');
                        }
                    } else {
                        setDisbursementApproveError(responseData?.info || "Failed to fetch disbursement.");
                        logFrontendException(storedUserId, pageName, "fetchDisbursementApprove", responseData?.info || '');
                    }
                } else {
                    setDisbursementApproveError(responseData?.info || "Failed to fetch disbursement.");
                    logFrontendException(storedUserId, pageName, "fetchDisbursementApprove", responseData || '');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setDisbursementApproveError("Unauthorized access. Your session may have expired. Please log in again.");
                setIsLoginPopup(true)
                //  Log exception to backend (User Id,Page Name,Method Name,Response/error)
                logFrontendException(storedUserId, pageName, "fetchDisbursementApprove", responseData || response || '');
            } else {
                setDisbursementApproveError(responseData?.info || "Failed to fetch disbursement.");
                logFrontendException(storedUserId, pageName, "fetchDisbursementApprove", responseData || '');
            }
        } catch (err) {
            setDisbursementApproveError("Network error. Please try again.");
            logFrontendException(storedUserId, pageName, "fetchDisbursementApprove", err || '');
        } finally {
            setDisbursementApproveLoading(false);
        }
    };

    const fetchYearList = async () => {
        try {
            setYearLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Make the API call
            const payLoad = { "code_id": "org_all_codes" }
            const response = await postData(ORG_GET_ALL_CODES_LIST, payLoad);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ) {
                            // Transforming the data
                            const yearListOption = await responseData?.dataJ?.financial_year_codes_list.map(service => ({
                                label: service.year_name,
                                value: service.year_id
                            }));

                            setYearList(yearListOption)
                            const defaultYear = yearListOption[0];
                            setSelectedYear(defaultYear);
                        } else {
                            setYearError(responseData?.info || 'Data Not Found');
                            logFrontendException(storedUserId, pageName, "fetchYearList", responseData?.info || '');
                        }
                    } else {
                        setYearError(responseData?.info || 'Failed to fetch data. Please try again.');
                        logFrontendException(storedUserId, pageName, "fetchYearList", responseData?.info || '');
                    }
                } else {
                    setYearError(responseData?.info || 'Something went wrong while processing your request.');
                    logFrontendException(storedUserId, pageName, "fetchYearList", responseData || '');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setYearError('Unauthorized access. Your session may have expired. Please log in again.');
                setIsLoginPopup(true);
                logFrontendException(storedUserId, pageName, "fetchYearList", responseData || '');
            } else {
                setYearError('Unexpected error occurred. Please try again later.');
                logFrontendException(storedUserId, pageName, "fetchYearList", responseData || response || '');
            }
        } catch (error) {
            setYearError(`Failed to fetch data. Please check your network connection and try again.`);
            logFrontendException(storedUserId, pageName, "fetchYearList", error || '');
        } finally {
            setYearLoading(false);
        }
    }

    const fetchAccountDashboardSummary = async (yearId) => {
        setDashboardSummaryLoading(true);
        setDashboardSummaryError("");
        setDashboardSummary({});
        const storedUser = JSON.parse(localStorage.getItem("_userInfo_"));

        try {
            const payload = {
                action_type: "account_dashboard_summary",
                emp_id_auth: storedUser?.emp_id,
                fy: yearId,
            };
            const response = await postData(ACCOUNT_DASHBOARD_SUMMARY_URL, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData.message.toLowerCase() === "success") {
                        if (responseData?.dataJ) {
                            setDashboardSummary(responseData.dataJ);
                        } else {
                            setDashboardSummaryError(responseData?.info || "No summary data found.");
                            logFrontendException(storedUser?.emp_id, pageName, "fetchAccountDashboardSummary", responseData || "");
                        }
                    } else {
                        setDashboardSummaryError(responseData?.info || "Message not success.");
                        logFrontendException(storedUser?.emp_id, pageName, "fetchAccountDashboardSummary", responseData || "");
                    }
                } else {
                    setDashboardSummaryError(responseData?.info || "Invalid statusCode.");
                    logFrontendException(storedUser?.emp_id, pageName, "fetchAccountDashboardSummary", responseData || "");
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setDashboardSummaryError('Unauthorized access. Your session may have expired. Please log in again.');
                setIsLoginPopup(true);
                logFrontendException(storedUser?.emp_id, pageName, "fetchAccountDashboardSummary", responseData || '');
            } else {
                setDashboardSummaryError(responseData?.info || "API failed.");
                logFrontendException(storedUser?.emp_id, pageName, "fetchAccountDashboardSummary", responseData || response || "");
            }
        } catch (err) {
            setDashboardSummaryError("Network error. Please try again.");
            logFrontendException(storedUser?.emp_id, pageName, "fetchAccountDashboardSummaryCatch", err || "");
        } finally {
            setDashboardSummaryLoading(false);
        }
    };

    const fetchNetBalanceReport = async (yearId) => {
        setNetBalanceLoading(true);
        setNetBalanceError("");
        setNetBalanceReport({});
        const storedUser = JSON.parse(localStorage.getItem("_userInfo_"));

        try {
            const payload = {
                action_type: "account_net_balance",
                emp_id_auth: storedUser?.emp_id,
                fy: yearId,
            };
            const response = await postData(ACCOUNT_NET_BALANCE_URL, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData.message.toLowerCase() === "success") {
                        if (responseData?.dataJ) {
                            setNetBalanceReport(responseData.dataJ);
                        } else {
                            setNetBalanceError(responseData?.info || "No net balance data found.");
                            logFrontendException(storedUser?.emp_id, "ExpenseManagementController", "fetchNetBalanceReport", responseData || "");
                        }
                    } else {
                        setNetBalanceError(responseData?.info || "Message not success.");
                        logFrontendException(storedUser?.emp_id, "ExpenseManagementController", "fetchNetBalanceReport", responseData || "");
                    }
                } else {
                    setNetBalanceError(responseData?.info || "Invalid statusCode.");
                    logFrontendException(storedUser?.emp_id, "ExpenseManagementController", "fetchNetBalanceReport", responseData || "");
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setNetBalanceError('Unauthorized access. Your session may have expired. Please log in again.');
                setIsLoginPopup(true);
                logFrontendException(storedUser?.emp_id, pageName, "fetchNetBalanceReport", responseData || '');
            } else {
                setNetBalanceError(responseData?.info || "API failed.");
                logFrontendException(storedUser?.emp_id, "ExpenseManagementController", "fetchNetBalanceReport", responseData || "");
            }
        } catch (err) {
            setNetBalanceError("Network error. Please try again.");
            logFrontendException(storedUser?.emp_id, "ExpenseManagementController", "fetchNetBalanceReport", err || "");
        } finally {
            setNetBalanceLoading(false);
        }
    };

    const fetchTotalExpenseData = async (yearId) => {
        setTotalExpenseLoading(true);
        setTotalExpenseError("");
        setTotalExpenseData({});
        const storedUser = JSON.parse(localStorage.getItem("_userInfo_"));
        const pageName = "ExpenseManagementController";

        try {
            const payload = {
                action_type: "pending_expense_disbursment",
                emp_id_auth: storedUser?.emp_id,
                fy: yearId,
            };
            
            const response = await postData(ACCOUNT_REPORTS_URL, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        setTotalExpenseData(responseData.dataJ);
                    } else {
                        setTotalExpenseError(responseData?.info || "Message not success.");
                        logFrontendException(storedUser?.emp_id, pageName, "fetchTotalExpenseData", responseData);
                    }
                } else {
                    setTotalExpenseError(responseData?.info || "Invalid statusCode.");
                    logFrontendException(storedUser?.emp_id, pageName, "fetchTotalExpenseData", responseData);
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setTotalExpenseError('Unauthorized access. Your session may have expired. Please log in again.');
                setIsLoginPopup(true);
                logFrontendException(storedUser?.emp_id, pageName, "fetchTotalExpenseData", responseData || '');
            } else {
                setTotalExpenseError("API failed.");
                logFrontendException(storedUser?.emp_id, pageName, "fetchTotalExpenseData", responseData);
            }
        } catch (err) {
            setTotalExpenseError("Network error.");
            logFrontendException(storedUser?.emp_id, pageName, "fetchTotalExpenseData", err);
        } finally {
            setTotalExpenseLoading(false);
        }
    };

    const fetchDisbursementReportData = async (yearId) => {
        setDisbursementReportLoading(true);
        setDisbursementReportError("");
        setDisbursementReportData({});
        const storedUser = JSON.parse(localStorage.getItem("_userInfo_"));
        const pageName = "ExpenseManagementController";

        try {
            const payload = {
                action_type: "disbursement_report",
                emp_id_auth: storedUser?.emp_id,
                fy: yearId,
            };
            const response = await postData(ACCOUNT_REPORTS_URL, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        setDisbursementReportData(responseData.dataJ);
                    } else {
                        setDisbursementReportError(responseData?.info || "Message not success.");
                        logFrontendException(storedUser?.emp_id, pageName, "fetchDisbursementReportData", responseData);
                    }
                } else {
                    setDisbursementReportError(responseData?.info || "Invalid statusCode.");
                    logFrontendException(storedUser?.emp_id, pageName, "fetchDisbursementReportData", responseData);
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setDisbursementReportError('Unauthorized access. Your session may have expired. Please log in again.');
                setIsLoginPopup(true);
                logFrontendException(storedUser?.emp_id, pageName, "fetchDisbursementReportData", responseData || '');
            } else {
                setDisbursementReportError("API failed.");
                logFrontendException(storedUser?.emp_id, pageName, "fetchDisbursementReportData", responseData || response || '');
            }
        } catch (err) {
            setDisbursementReportError("Network error.");
            logFrontendException(storedUser?.emp_id, pageName, "fetchDisbursementReportData", err || '');
        } finally {
            setDisbursementReportLoading(false);
        }
    };

    const fetchExpenseReportData = async (yearId) => {
        setExpenseReportLoading(true);
        setExpenseReportError("");
        setExpenseReportData({});
        const storedUser = JSON.parse(localStorage.getItem("_userInfo_"));
        const pageName = "ExpenseManagementController";

        try {
            const payload = {
                action_type: "expense_report",
                emp_id_auth: storedUser?.emp_id,
                fy: yearId,
            };

            const response = await postData(ACCOUNT_REPORTS_URL, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        setExpenseReportData(responseData.dataJ);
                    } else {
                        setExpenseReportError(responseData?.info || "Message not success.");
                        logFrontendException(storedUser?.emp_id, pageName, "fetchExpenseReportData", responseData);
                    }
                } else {
                    setExpenseReportError(responseData?.info || "Invalid statusCode.");
                    logFrontendException(storedUser?.emp_id, pageName, "fetchExpenseReportData", responseData);
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setExpenseReportError('Unauthorized access. Your session may have expired. Please log in again.');
                setIsLoginPopup(true);
                logFrontendException(storedUser?.emp_id, pageName, "fetchExpenseReportData", responseData || '');
            } else {
                setExpenseReportError("API failed.");
                logFrontendException(storedUser?.emp_id, pageName, "fetchExpenseReportData", responseData || response || '');
            }
        } catch (err) {
            setExpenseReportError("Network error.");
            logFrontendException(storedUser?.emp_id, pageName, "fetchExpenseReportData", err || '');
        } finally {
            setExpenseReportLoading(false);
        }
    };

    const fetchRejectionReportData = async (yearId) => {
        setRejectionReportLoading(true);
        setRejectionReportError("");
        setRejectionReportData({});
        const storedUser = JSON.parse(localStorage.getItem("_userInfo_"));
        const pageName = "ExpenseManagementController";

        try {
            const payload = {
                action_type: "rejection_report",
                emp_id_auth: storedUser?.emp_id,
                fy: yearId,
            };
            const response = await postData(ACCOUNT_REPORTS_URL, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        setRejectionReportData(responseData.dataJ);
                    } else {
                        setRejectionReportError(responseData?.info || "Message not success.");
                        logFrontendException(storedUser?.emp_id, pageName, "fetchRejectionReportData", responseData);
                    }
                } else {
                    setRejectionReportError(responseData?.info || "Invalid statusCode.");
                    logFrontendException(storedUser?.emp_id, pageName, "fetchRejectionReportData", responseData);
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setRejectionReportError('Unauthorized access. Your session may have expired. Please log in again.');
                setIsLoginPopup(true);
                logFrontendException(storedUser?.emp_id, pageName, "fetchRejectionReportData", responseData || '');
            } else {
                setRejectionReportError("API failed.");
                logFrontendException(storedUser?.emp_id, pageName, "fetchRejectionReportData", responseData);
            }
        } catch (err) {
            setRejectionReportError("Network error.");
            logFrontendException(storedUser?.emp_id, pageName, "fetchRejectionReportData", err);
        } finally {
            setRejectionReportLoading(false);
        }
    };

    const onRefresh = () => {
        fetchAccountDashboardSummary(selectedYear.value);
        fetchNetBalanceReport(selectedYear.value);
        fetchTotalExpenseData(selectedYear.value);
        fetchDisbursementReportData(selectedYear.value);
        fetchExpenseReportData(selectedYear.value);
        fetchRejectionReportData(selectedYear.value);
        fetchExpenses();
        fetchExpenseApprove();
        const storedUserInfo = JSON.parse(localStorage.getItem("_userInfo_"));   
        const userRole = storedUserInfo?.emp_role
        console.log("userRole if",userRole)
        if(userRole == 'Super Admin'){
            console.log("userRole if",userRole)
            fetchDisbursementList();
        }    
         

    }

    const onExpRefresh = () => {
        fetchAccountDashboardSummary(selectedYear.value);
        fetchNetBalanceReport(selectedYear.value);
        fetchTotalExpenseData(selectedYear.value);
        fetchDisbursementReportData(selectedYear.value);
        fetchExpenseReportData(selectedYear.value);
        fetchRejectionReportData(selectedYear.value);
        fetchExpenses();
        fetchExpenseApprove();
        fetchDisbursementList();
        fetchDisbursementApprove();
    }

    const onDisRefresh = () => {
        fetchAccountDashboardSummary(selectedYear.value);
        fetchNetBalanceReport(selectedYear.value);
        fetchTotalExpenseData(selectedYear.value);
        fetchDisbursementReportData(selectedYear.value);
        fetchExpenseReportData(selectedYear.value);
        fetchRejectionReportData(selectedYear.value);
        fetchDisbursementList();
        fetchDisbursementApprove();
    }

    useEffect(() => {
        if (selectedYear) {
            fetchAccountDashboardSummary(selectedYear.value);
            fetchNetBalanceReport(selectedYear.value);
            fetchTotalExpenseData(selectedYear.value);
            fetchDisbursementReportData(selectedYear.value);
            fetchExpenseReportData(selectedYear.value);
            fetchRejectionReportData(selectedYear.value);
        }
    }, [selectedYear]);


    useEffect(() => {
        fetchExpenses();
        fetchExpenseApprove();
        fetchYearList();
        fetchDisbursementList();
        fetchDisbursementApprove();
    }, []);

    return {
        expenseList,
        expenseLoading,
        expenseError,
        fetchExpenses,
        expenseApproveList,
        expenseApproveLoading,
        expenseApproveError,
        fetchExpenseApprove,
        yearError,
        yearLoading,
        yearList,
        setSelectedYear,
        selectedYear,
        dashboardSummary, dashboardSummaryLoading, dashboardSummaryError,
        netBalanceReport, netBalanceLoading, netBalanceError,
        totalExpenseData, totalExpenseLoading, totalExpenseError,
        disbursementReportData, disbursementReportLoading, disbursementReportError,
        expenseReportData, expenseReportLoading, expenseReportError,
        rejectionReportData, rejectionReportLoading, rejectionReportError,
        onRefresh,
        disbursementList,
        disbursementbLoading,
        disbursementError,
        fetchDisbursementList,


        disbursementApproveError,
        disbursementApproveLoading,
        disbursementApproveList,
        fetchDisbursementApprove,
        setDisbursementApproveError,
        setDisbursementApproveLoading,
        setDisbursementApproveList,

        setDisbursementList,
        setDisbursementError,
        setDisbursementLoading,
        onDisRefresh,
        onExpRefresh,
    };
};

export default ExpenseManagementController;
